// src/components/AppointmentList/AppointmentReceipt.jsx
import React from 'react';
import './AppointmentReceipt.css';
import logo from "./logo.png";
import roundlogo from "./roundlogo.png";

const AppointmentReceipt = React.forwardRef(({ data }, ref) => {
    if (!data) return null;

    const isSuccess = data.status === 'confirmed' || data.paymentStatus === 'paid';
    const statusText = isSuccess ? 'Appointment Confirmed' : 'Booking Failed';
    const statusClass = isSuccess ? 'success' : 'failed';
    const statusIcon = isSuccess ? 'fas fa-check-circle' : 'fas fa-times-circle';

    // === FIX #1: Add appointmentNumber to this list ===
    const {
        _id,
        appointmentNumber, // <-- ADDED THIS LINE
        appointmentDate,
        appointmentTime,
        doctorName,
        patientName,
        patientPhone,
        doctorFee,
        paymentStatus,
        status,
        createdAt,
        paymentDetails,
    } = data;

    return (
        <div className={`receipt-pdf-wrapper ${statusClass}`} ref={ref}>
            <div className="receipt-pdf-header">
                <div className="receipt-pdf-header-text">
                      <img src={roundlogo} alt="Hospital Round Logo" className="receipt-pdf-round-logo" />
                </div>
                <img src={logo} alt="Hospital Logo" className="receipt-pdf-logo" />
            </div>

            <div className="receipt-pdf-status-banner">
                 <i className={`${statusIcon} receipt-pdf-status-icon`}></i>
                <h3 className="receipt-pdf-status-title">{statusText}</h3>
            </div>

            <div className="receipt-pdf-body">
                <p className="receipt-pdf-greeting">
                    Dear <strong>{patientName || 'Valued Patient'}</strong>, here are the details of your transaction.
                </p>

                <div className="receipt-pdf-section">
                    <h4>Appointment Details</h4>
                    <div className="receipt-pdf-grid">
                        {/* === FIX #2: Display the appointmentNumber correctly === */}
                        <span>Appointment No:</span><code className="receipt-pdf-code">{appointmentNumber || 'N/A'}</code>
                        <span>Doctor:</span><strong>Dr. {doctorName || 'N/A'}</strong>
                        <span>Date & Time:</span><strong>{appointmentDate ? new Date(appointmentDate).toLocaleDateString() : 'N/A'} at {appointmentTime || 'N/A'}</strong>
                        <span>Booking ID:</span><code className="receipt-pdf-code">{_id || 'N/A'}</code>
                        <span>Appt. Status:</span><strong className={`status-text-${status?.toLowerCase()}`}>{status?.replace(/_/g, ' ')?.toUpperCase() || 'N/A'}</strong>
                        {/* The incorrect block has been removed */}
                    </div>
                </div>

                <div className="receipt-pdf-section">
                    <h4>Payment Information</h4>
                    <div className="receipt-pdf-grid">
                        <span>Fee Amount:</span><strong>₹{doctorFee?.toFixed(2) || '0.00'}</strong>
                        <span>Payment Status:</span><strong className={`status-text-${paymentStatus?.toLowerCase()}`}>{paymentStatus?.replace(/_/g, ' ')?.toUpperCase() || 'N/A'}</strong>
                        <span>Transaction Date:</span><strong>{new Date(createdAt || Date.now()).toLocaleString()}</strong>
                    </div>
                </div>

                 <div className="receipt-pdf-section">
                    <h4>Patient Information</h4>
                    <div className="receipt-pdf-grid">
                        <span>Name:</span><strong>{patientName || 'N/A'}</strong>
                        <span>Phone:</span><strong>{patientPhone || 'N/A'}</strong>
                    </div>
                </div>
            </div>

            <div className="receipt-pdf-footer">
                <p>Thank you for choosing Hitkari Hospital. For any assistance, please contact our support.</p>
            </div>
        </div>
    );
});

export default AppointmentReceipt;